class ChiefComplaint {
  constructor(title, code, category) {
    this.title = title;
    this.code = code;
    this.category = category;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      chiefComplaintId: null,
      searchTitle: '',
      disabelConfirm: false,
      isAttachmentModalOpen: false,
      addFlag: false,
      isActive: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      chiefComplaintManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'کد', value: 'code', align: 'center' },
        { text: 'دسته بندی', value: 'category', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      actionList: [
        {
          title: 'پرسش های کلیدی',
          id: '1',
          type: 'showQuestions',
          icon: 'mdi-help mdi-18px',
        },
        {
          title: 'پاسخ ها',
          id: '2',
          type: 'showAnswers',
          icon: 'mdi-message-text mdi-18px',
        },
        {
          title: 'تریاژ بالینی',
          id: '3',
          type: 'showClinicalTriage',
          icon: 'mdi-hospital-box-outline mdi-18px',
        },
        {
          title: 'توصیه و راهنمایی',
          id: '4',
          type: 'showAdviceGuidance',
          icon: 'mdi-face-agent mdi-18px',
        },
      ],
      searchCategory: null,
      searchText: '',
      chiefComplaintphoneNumbers: [],
    };
  },
  methods: {
    setChiefComplaintId: function (id) {
      this.chiefComplaintId = id;
    },
    // attachment modal methods
    showAttachmentModal: function (id) {
      this.isAttachmentModalOpen = true;
      this.getAllTrainings();
      this.setChiefComplaintId(id);
      this.getAllChiefComplaintAttchments(id);
    },
    cancelAttachmentModal: function () {
      this.isAttachmentModalOpen = false;
      this.setChiefComplaintId(null);
      this.clearAttachments();
    },
    // add or edit modal methods
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن تشخیص احتمالی پرستار';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش تشخیص احتمالی پرستار';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getChiefComplaintFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.isActive = false;
      this.chiefComplaint = new ChiefComplaint('', '', null);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addChiefComplaintFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش تشخیص احتمالی پرستار';
        this.$refs.confirm.text = 'از ویرایش تشخیص احتمالی پرستار اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف تشخیص احتمالی پرستار';
        this.$refs.confirm.text = 'از حذف تشخیص احتمالی پرستار اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addChiefComplaintFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editChiefComplaintFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteChiefComplaintFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete chiefComplaint entity
    showDeleteConfirmFunction: function (id) {
      this.setChiefComplaintId(id);
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfChiefComplaintsWithPagination();
    },
    removeFilters: function () {
      this.searchCategory = null;
      this.searchText = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfChiefComplaintsWithPagination();
    },
    cancelSearch: function () {
      this.searchCategory = null;
      this.searchText = '';
      this.searchModal = false;
    },
    goToTriageQuestion: function (id) {
      localStorage.setItem('adminCheifComplaint', id);
      this.$router.push({ name: 'triageQuestion' });
    },
    goToClinicalTriage: function (id) {
      this.$router.push({ name: 'clinicalTriage', params: { id: id } });
    },
    actionDropdownBtn: function (type, item) {
      const actionRoute =
        type === 'showQuestions'
          ? `/chiefComplaint/${item.id}/questions`
          : type === 'showAnswers'
            ? `/chiefComplaint/${item.id}/answers`
            : type == 'showClinicalTriage'
              ? `/chiefComplaint/${item.id}/clinical_triage`
              : `/chiefComplaint/${item.id}/advice_guidance`;
      this.$router.push(actionRoute);
    },
  },
};
